import React from 'react';

const NotGet = () => {
    return (
        <div style={{ marginTop: '20px' }}>
            <h3>Something Went Wrong</h3>
        </div>
    );
};

export default NotGet;